import { ArticleModel } from 'src/app/models/archive/article.model';
import { DevolutionModel } from './devolution.model';
import { RepairModel } from '../maintenance/repair.model';

export class DevolutionDetailModel {
  devolutionDetailId: number = 0;
  devolutionId: number = 0;
  devolution: DevolutionModel = new DevolutionModel();
  articleId: number = 0;
  article: ArticleModel = new ArticleModel();
  storeId: number = 0;
  predevolutionQuantity: number = 0;
  quantity: number = 0;
  cleaningQuantity: number = 0;
  cleaningValue: number = 0;
  repairQuantity: number = 0;
  repairValue: number = 0;
  replacementQuantity: number = 0;
  replacementValue: number = 0;
  swGenerateMaintenanceOrder: boolean = false;
  createDate: string = "";
  userNameCreate: string = "";
  updateDate: string | null = null;
  userNameUpdate: string | null = null;

  //Solo se usa en el front
  replacementUnitValue: number = 0;
  hasRepairs: boolean = false;
  repairs: Array<RepairModel> = new Array<RepairModel>();
}